import { createImageAssetHandler, createVideoAssetHandler, createAudioAssetHandler } from './handlers';
import { UploadedAsset } from '@/components/molecules/MultiAssetUploader/types';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { useAppContext } from '@/context/AppContext/AppContext';

export const useClipAsset = () => {
  const { clipData, clipId } = useClipsContext();
  const { logger } = useAppContext();

  const addClipAsset = async ({
    currentFrame,
    asset,
    type
  }: {
    currentFrame: number;
    asset: UploadedAsset;
    type: string;
  }) => {
    const handlers = {
      image: createImageAssetHandler(clipData, clipId),
      video: createVideoAssetHandler(clipData, clipId),
      audio: createAudioAssetHandler(clipData, clipId)
    };

    const handler = handlers[type as keyof typeof handlers];
    if (!handler) {
      return;
    }

    try {
      await handler(currentFrame, asset);
    } catch (error) {
      logger.error('Error adding image asset:', error);
    }
  };

  return {
    addClipAsset
  };
};
